import React, { createContext, useMemo, useState } from "react"
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

const ColorModeContext = createContext()

//-----------------------------------------------------------------
function ColorModeProvider( { children } ) {
  //-----------------------------------------------------------------

  const is_dark = localStorage.getItem('theme') === 'dark';
  const [mode, setMode] = useState(is_dark ? 'dark' : 'light');

  const colorMode = useMemo(
    () => ({
      toggle: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = useMemo(  
    () => createTheme( {
    palette: {
      mode: mode,
      background: {
        primary: {
          light : '#ffffff' ,
          dark  : '#1E252D' ,
        },
        secondary: {
          light : '#dedede' ,
          dark  : '#0a0f1e' ,
        }
      },
      panel: {
        light : grey[200],
        dark  : '#121212',
      },
      primary: {
        /* pd-blue */
        main  : '#0886bc' ,
        dark  : '#0e6d95' ,
        light : '#3399C7' ,
        alt   : {
          main  : '#BD3E08',
          dark  : '#94360D',
          light : '#C76234',
        }
        /* purple */
        // light : '#8133EE' ,
        // main  : '#44296b' ,
        // dark  : '#2e1056' ,
      },
      secondary: {
        main: '#b90082',
      },
      info: {
        main: '#0886bc',
      },
      status: {
        passed: {
          main: '#00b994',
        },
        failed: {
          main: '#b90025',
        },
        certain: {
          main: '#00e100',
        },
        review: {
          light : '#a9a9a9',
          dark  : '#FFFFFF',
        }
      }
    },
    typography: {
      fontSize: 16,
    },
  } ), [mode] );

  return (
    <ColorModeContext.Provider value={ colorMode }>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export { ColorModeContext, ColorModeProvider };